import './home.css';

const Home = () => {
  return (
    <>
      <div className="row">
        {/* Carousel */}
        <div id="myCarousel" className="carousel slide" data-ride="carousel">
          {/* Indicators */}
          <ol className="carousel-indicators">
            <li
              data-target="#myCarousel"
              data-slide-to="0"
              className="active"
            ></li>
            <li data-target="#myCarousel" data-slide-to="1"></li>
            <li data-target="#myCarousel" data-slide-to="2"></li>
            <li data-target="#myCarousel" data-slide-to="3"></li>
            <li data-target="#myCarousel" data-slide-to="4"></li>
            <li data-target="#myCarousel" data-slide-to="5"></li>
            <li data-target="#myCarousel" data-slide-to="6"></li>
            <li data-target="#myCarousel" data-slide-to="7"></li>
            <li data-target="#myCarousel" data-slide-to="8"></li>
            <li data-target="#myCarousel" data-slide-to="9"></li>
            <li data-target="#myCarousel" data-slide-to="10"></li>
            <li data-target="#myCarousel" data-slide-to="11"></li>
            <li data-target="#myCarousel" data-slide-to="12"></li>
           {/*  <li data-target="#myCarousel" data-slide-to="13"></li>
            <li data-target="#myCarousel" data-slide-to="14"></li>
            <li data-target="#myCarousel" data-slide-to="15"></li>
            <li data-target="#myCarousel" data-slide-to="16"></li>
            <li data-target="#myCarousel" data-slide-to="17"></li>
            <li data-target="#myCarousel" data-slide-to="18"></li>
            <li data-target="#myCarousel" data-slide-to="19"></li>
            <li data-target="#myCarousel" data-slide-to="20"></li>
            <li data-target="#myCarousel" data-slide-to="21"></li> */}
          </ol>
          <div className="carousel-inner" role="listbox">
              {/* Mary Stuart */}
            <div className="item active">
              <img
                className="slide"
                src="/images/mary/MaryStuart-171-X3.jpg"
                alt="Mary Stuart"
              />
              {/*confrontation*/}
            </div>
            <div className="item">
              <img
                className="slide"
                src="/images/mary/MaryStuart-323-X3.jpg"
                alt="Mary Stuart"
              />
              {/*martyr Mary*/}
            </div>



            <div className="item">
              <img
                className="slide"
                src="/images/mary/MaryStuart-316-X3.jpg"
                alt="Mary Stuart"
              />
              {/*execution*/}
            </div>
            <div className="item">
              <img
                className="slide"
                src="/images/arachne/Arachne9.jpg"
                alt="Arachne"
              />
              {/*arachne*/}
            </div>

            <div className="item">
              <img
                className="slide"
                src="/images/cave/Cave-16.jpg"
                alt="The Cave"
              />
              {/*TV*/}
            </div>
            <div className="item">
              <img
                className="slide"
                src="/images/cave/Cave-38.jpg"
                alt="The Cave"
              />
              {/*Uncle Neil*/}
            </div>

           
            <div className="item">
              <img
                className="item"
                src="/images/rachel/SAM02809.jpg"
                alt="My Name is Rachel Corrie"
              />{' '}
              {/*Rachel*/}
            </div>

            {/* Spring Awakening */}
            <div className="item">
              <img
                className="slide"
                src="/images/spring/boys.jpg"
                alt="Spring Awakening"
              />
              {/*boys*/}
            </div>

            {/* Viterbo */}

            <div className="item">
              <img
                className="slide"
                src="/images/elephant/_APR4003_1200px.jpg"
                alt="Elephant Speaks Jazz"
              />
            </div>

            <div className="item">
              <img
                className="slide"
                src="/images/pajama/IMG_3533-Overhouse.jpg"
                alt="Pajama Game"
              />
            </div>

            {/* Anna/Kate */}

            <div className="item">
              <img
                className="slide"
                src="/images/annakate_gallery/irunwithyou6.JPG"
                alt="Anna/Kate"
              />
            </div>
            {/* Dijla Wal Furat */}


            <div className="item">
              <img
                className="slide"
                src="/images/carousel/Web_Y1A0602.jpg"
                alt="Dijla Wal Furat"
              />
              {/*Fahim*/}
            </div>

            <div className="item">
              <img
                className="slide"
                src="/images/carousel/Telling_Victoria.jpg"
                alt="Telling"
              />
            </div>

          </div>
          <a
            className="left carousel-control"
            href="#myCarousel"
            role="button"
            data-slide="prev"
          >
            <span
              className="glyphicon glyphicon-chevron-left"
              aria-hidden="true"
            ></span>
            <span className="sr-only">Previous</span>
          </a>
          <a
            className="right carousel-control"
            href="#myCarousel"
            role="button"
            data-slide="next"
          >
            <span
              className="glyphicon glyphicon-chevron-right"
              aria-hidden="true"
            ></span>
            <span className="sr-only">Next</span>
          </a>
        </div>
        {/* /.carousel */}
      </div>
      <div className="col-sm-16" id="homecontent">
          <span className="playsnoemp">
            <br />
            <strong>On tap for 2026</strong>
            <ul>
              <li>A reading of <em>Flower Girl</em> by Maddie Kovach for Avalanche Theatre's Show & Tell Showcase</li>
              <li>Industry readings of <a href="https://newplayexchange.org/script/3258071/a-fatal-place" target="_blank" rel="noreferrer"><em>A Fatal Place</em></a>, Hallie Palladino's darkly comic, Bronze Age plus social media adaptation of <em>Iphigenia at Aulis</em>.</li>
              <li>The launch of JunkHeart, a new collaboration with Tatiana Pavela, with a workshop and public reading of <em>Red Solo Cups</em> by B. Walker Sampson, supported by the Independent Productions Initiative and Grey Area Productions.</li>    
              <li>A workshop of Aisha Hamid's <em>Girls, Girls, Girls!</em> for Avalanche Theatre's NEXT DRAFT series.</li>
              <li><em>A Map of Me</em> by Jeremy Ohringer for The Theatre School's Playworks Series at DePaul University, coming Fall 2026.</li>
            </ul>
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center'
            }}>
            <img
          src="/images/RSCgraphic.jpg"
          alt="Red Solo Cups reading February 7th graphic"
          style={{
            maxWidth: "100%",
            width: "400px",
            padding: 20,
          }}
        />

            </div>
            <strong>2025 Highlights</strong>
            <ul>
            
              <li>Chicago Equity storefront directing debut with the extended world-premiere of <em>The Cave</em> at A Red Orchid Theatre, nominated for an Equity Jeff Award for New Work.</li>
              <li>Became a Full Member of the Stage Directors & Choreographers Society (SDC), the union representing stage directors and choreographers.</li>
              <li>Presented "Cultivating Community through Authentic Audience/Artist Exchange" at the Association for Theatre in Higher Education (ATHE) 2025 conference.</li>
              <li><em>Arachne</em>, written and performed by Britt Anderson, ran for a month at the Edinburgh Fringe Festival. <a href="https://theatreweekly.com/edinburgh-fringe-review-arachne-at-greenside-riddles-court-willow-studio/" target="_blank" rel="noreferrer">Read this four-star review from Theatre Weekly</a>.</li>
              <li>In September, <em>My Name is Rachel Corrie</em> traveled to Berea, KY for a residency with Clear Creek Creative.</li>
              <li>Sold-out debut performance of Caroline Rothstein's new one-woman play <em>Come Inside</em> at Caveat NYC on November 9.</li>
            </ul>
            <br></br>
          </span>
             
          <span className="playsnoemp">
                  <strong>About The Metal Shop Performance Lab</strong>
             <p>
                Alex created The Metal Shop in August 2019 with the mission to
                create theatrical events that foster radical community-building
                and authentic exchange between artists and audiences. Please
                visit{' '}
                <a href="https://www.themetalshop.org" target="_blank" rel="noreferrer">
                  https://www.themetalshop.org
                </a>{' '}
                to learn more about our current projects or to get involved.
              </p>

    
           
          </span>
       
      </div>
    </>
  );
};
export default Home;
